import React, { useEffect, useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import SchoolIcon from "@mui/icons-material/School";
import { Box, Drawer, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import Addschool from "../../component/AddSchool";
import DataGrid from "../../component/DataGrid";
import ModalDialog from "../../component/Modal";
import SelectField from "../../component/SelectField";
import Toaster from "../../component/Toaster";
import SimpleDate from "../../component/simpleDate";
import { CommonService } from "../../store/common/CommonSlice";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import { studentLeadAction } from "../../store/studentLeads/studentLeadSlice";
import { studentMasterService } from "../../store/studentMaster/StudentMasterSlice";
import { DATE_FORMATS, DateTimeUtil } from "../../util/DateTimeUtils";
import { LOOKUP, THEME } from "../../util/LookupConst";
import { CommonUtil, LoginUserDetails, Product } from "../../util/Utils";
import RightDrawerLarge from "../Drawer/RightDrawerLarge";
import RegisterNewStudent from "../registerStudent/registerNewStudent";
import "../student/leads/Leads.scss";

export default function LeadDetails() {
  const dispatch = useDispatch<any>();
  const { t } = useTranslation();
  const [ragisterDrawerOpen, setRagisterDrawerOpen] = useState(false);
  const [ragisterDrawer, setRagisterDrawer] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [todayLeadDetails, setTodayLeadDetails] = useState<any>([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [ciNameOptions, setCiNameOptions] = useState<any>([]);
  const [batchNameOptions, setBatchNameOptions] = useState<any>([]);
  const [promoCodeOptions, setPromoCodeList] = useState<any>([]);
  const [courseNameOptions, setCourseNameOptions] = useState<any>([]);
  const [sourceOfEnquiryOptions, setSourceOfEnquiryOptions] = useState([]);
  const [modeOfPaymentOptions, setModeOfPaymentOptions] = useState<any>([]);
  const [primaryBenefitOptions, setPrimaryBenefitOptions] = useState<any>([]);
  const [refferedByOptions, setRefferedByOptions] = useState([]);
  const [levelStatusOptions, setLevelStatusOptions] = useState<any>([]);
  const [registrationTypeOptions, setRegistrationTypeOptions] = useState<any>(
    []
  );
  const [followUpRemarksOptions, setFollowUpRemarksOptions] = useState<any>([]);
  const [lead, setLead] = useState<any>(undefined);
  const programName = Product.ProductCode();

  const handleRegisterDrawerOpen = () => {
    setRagisterDrawerOpen(!ragisterDrawerOpen);
  };

  const handleRegisterDrawerClose = () => {
    setRagisterDrawer(false);
  };

  const handleRagisterDrawerClose = () => {
    setRagisterDrawerOpen(false);
  };

  const handleOpenStudentModal = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    handleRegisterDrawerOpen();
  };

  const schoolNameAdded = (data: any) => {
    if (data.status === 200) {
      //getSchoolList(); Need to call school get API
      setModalOpen(false);
    }
  };

  const onChangeFollowUpRemarks = (lead: any, followUpRemarks: any) => {
    const clonedLeads = CommonUtil.copyObject(todayLeadDetails);
    const objIndex = todayLeadDetails.findIndex(
      (obj: any) => lead.id === obj.id
    );
    clonedLeads[objIndex].followUpRemarksId = followUpRemarks;
    let params: any = {
      followUpRemarksId: followUpRemarks,
      nextFollowUpDate:
        lead.nextFollowUpDateDDMMYYYY ||
        DateTimeUtil.format(
          lead.nextFollowUpDate,
          DATE_FORMATS.DDMMYYYY_SLASH
        ) ||
        null,
    };
    setTodayLeadDetails(clonedLeads);
    callFollowUpRemarksAPI(lead, params);
  };

  const onChangeNextFollowUpDate = (lead: any, nextFollowUpDate: any) => {
    const clonedLeads = CommonUtil.copyObject(todayLeadDetails);
    const objIndex = clonedLeads.findIndex((obj: any) => lead.id === obj.id);
    const date = DateTimeUtil.format(
      nextFollowUpDate,
      DATE_FORMATS.DDMMYYYY_SLASH
    );
    clonedLeads[objIndex].nextFollowUpDateDDMMYYYY = date;
    clonedLeads[objIndex].nextFollowUpDate = nextFollowUpDate;
    const params = {
      nextFollowUpDate: date,
      followUpRemarksId:
        (followUpRemarksOptions?.find(
          (item: any) => lead.followUpRemarks?.name === item.label
        )?.value ||
          lead?.followUpRemarksId) ??
        null,
    };
    setTodayLeadDetails(clonedLeads);
    callFollowUpRemarksAPI(lead, params);
  };

  const callFollowUpRemarksAPI = (lead: any, params: any) => {
    dispatch(
      studentLeadAction({
        apiAction: "followUp",
        leadId: lead.id,
        params,
      })
    )
      .then((result: any) => {
        // this is added purposefully as we are not showing toast message
        if (result?.payload?.status === 200) {
          console.log(result.payload.data.message);
        } else {
          console.log(result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const getSelectOption = () => {
    dispatch(CommonService({ apiAction: "Course" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setCourseNameOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data.data,
              "courseName"
            )
          );
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });

    dispatch(CommonService({ apiAction: "Country" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setCountryOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data.data,
              "countryName"
            )
          );
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });

    dispatch(studentMasterService({ apiAction: "ci_name" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setCiNameOptions(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.courseInstructorName, value: item.id };
            })
          );
        }
      })
      .catch((e: any) => {
        console.log(e);
      });

    dispatch(studentMasterService({ apiAction: "batch_name" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setBatchNameOptions(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.batchName, value: item.id };
            })
          );
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
    dispatch(studentMasterService({ apiAction: "promoCode" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setPromoCodeList(
            CommonUtil.formateDropdownList(
              result?.payload?.data.data,
              "promoCode"
            )
          );
        }
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        // setSpinner(false);
      });
  };

  const getLookupValues = (values: any) => {
    dispatch(CommonService(values))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setSourceOfEnquiryOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[LOOKUP.ENQUIRY_SOURCE],
              "name"
            )
          );
          setFollowUpRemarksOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[LOOKUP.FOLLOW_UP_REMARKS],
              "name"
            )
          );
          setRefferedByOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[LOOKUP.REFERRED_BY],
              "name"
            )
          );
          setModeOfPaymentOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[LOOKUP.MODE_OF_PAYMENT],
              "name"
            )
          );
          setPrimaryBenefitOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[
                programName === THEME.SA
                  ? LoginUserDetails.getCountry() === "United States"
                    ? LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_US
                    : LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT
                  : programName === THEME.GA
                  ? LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_GA
                  : LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_CRICO
              ],
              "name"
            )
          );
          setRegistrationTypeOptions(
            result?.payload?.data?.data[LOOKUP.REGISTRATION_TYPE]
          );
          setLevelStatusOptions(
            CommonUtil.formateDropdownList(
              result?.payload?.data?.data[LOOKUP.LEVEL_STATUS],
              "name"
            )
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  // Get Lead based on ID
  const getLeadId = (leadId: any) => {
    dispatch(
      studentLeadAction({ leadId: leadId, apiAction: "student_lead_by_id" })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setLead(result?.payload?.data.data);
          setRagisterDrawer(true);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const columns = [
    {
      name: `${t("studentName")}`,
      selector: (row: any) => row.studentName,
      Cell: (row: any) => <a href={row.studentName}> {row.studentName} </a>,
      sortable: true,
    },
    {
      name: `${t("mobileNo")}`,
      selector: (row: any) => row.primaryMobileNumber,
    },
    {
      name: `${t("sourceOfEnquiry")}`,
      selector: (row: any) => row?.sourceOfEnquiry?.name,
      sortable: true,
      sortFunction: (rowA: any, rowB: any) => {
        return CommonUtil?.caseInsensitiveSort(
          rowA?.sourceOfEnquiry?.name,
          rowB?.sourceOfEnquiry?.name
        );
      },
    },
    {
      name: `${t("followUpRemarks")}`,
      selector: (row: any) => row.followUpRemarks,
      cell: (row: any) => (
        <Box className="batchWidth">
          <SelectField
            name="followUpRemarks"
            placeHolder={t("select")}
            value={
              row?.followUpRemarksId ||
              followUpRemarksOptions?.find(
                (item: any) => row?.followUpRemarks?.name === item.label
              )?.value ||
              t("select")
            }
            onChange={(e: any) => onChangeFollowUpRemarks(row, e.target.value)}
            options={followUpRemarksOptions}
          />
        </Box>
      ),
      width: "12%",
    },
    {
      name: `${t("nextFollowupDate")}`,
      selector: (row: any) => row.nextFollowUpDate,
      cell: (row: any) => (
        <Box className="full">
          <SimpleDate
            className="textField"
            name="nextFollowUpDate"
            format={"DD/MM/YYYY"}
            value={row.nextFollowUpDate ? dayjs(row.nextFollowUpDate) : null}
            onChange={(value: any) => onChangeNextFollowUpDate(row, value)}
          />
        </Box>
      ),
      width: "13%",
    },
    {
      name: `${t("enquiryDate")}`,
      selector: (row: any) => row.enquiryDate,
      width: "13%",
      sortable: true,
      sortFunction: (rowA: any, rowB: any) => {
        return CommonUtil?.caseInsensitiveDateSort(
          rowA?.enquiryDate,
          rowB?.enquiryDate
        );
      },
    },
    {
      name: `${t("workshopDoneDate")}`,
      selector: (row: any) => row.workshopDoneDate,
      center: "true",
      sortable: true,
      sortFunction: (rowA: any, rowB: any) => {
        const dateA = rowA?.workshopDoneDate || "";
        const dateb = rowB?.workshopDoneDate || "";
        return CommonUtil?.caseInsensitiveDateSort(dateA, dateb);
      },
    },
    {
      name: `${t("register")}`,
      cell: (row: any) => (
        <Box className="grid-action">
          <Tooltip title={t("registerANewStudent")} placement="left">
            <button
              disabled={row.register ? true : false}
              onClick={() => getLeadId(row.id)}
            >
              <SchoolIcon
                className={
                  row.register ? "font-20 disabled " : "font-20 g-yellow-dark"
                }
              />
            </button>
          </Tooltip>
        </Box>
      ),
      center: true,
    },
  ];

  const getTodayLeadDetails = () => {
    dispatch(dashboardAction({ apiAction: "getTodayLeadDetails" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setTodayLeadDetails(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getSelectOption();
    getTodayLeadDetails();
    getLookupValues({
      apiAction: "Lookup",
      lookup: [
        LOOKUP.FOLLOW_UP_REMARKS,
        LOOKUP.ENQUIRY_SOURCE,
        LOOKUP.REFERRED_BY,
        LOOKUP.MODE_OF_PAYMENT,
        programName === THEME.SA
          ? LoginUserDetails.getCountry() === "United States"
            ? LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_US
            : LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT
          : programName === THEME.GA
          ? LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_GA
          : LOOKUP.PRIMARY_BENEFIT_YOU_EXPECT_CRICO,
        LOOKUP.REGISTRATION_TYPE,
        LOOKUP.LEVEL_STATUS,
      ],
    });
  }, []);

  const handleModifiedStudentData = (data: any) => {
    if (data.status === 200) getTodayLeadDetails();
  };

  return (
    <div className="padding-y-10 padding-left-10 margin-right-10">
      <div className="padding-up-8 dashboard-heading">
        <div className="font-14 bolder">{t("todaysleaddetails")}</div>
      </div>
      <DataGrid
        columns={columns}
        selectableRows={false}
        data={todayLeadDetails}
        selectableRowsHighlight={true}
        highlightOnHover={true}
      />
      <div>
        {(["right"] as const).map((anchor) => (
          <React.Fragment key={anchor}>
            <Drawer
              className="dashboard-stepper"
              // style={{ width: "900px" }}
              sx={{
                flexShrink: 0,
                "& .MuiDrawer-paper": {},
                zIndex: 1202,
                width: "900px",
              }}
              anchor={anchor}
              open={ragisterDrawerOpen}
              onClose={handleRagisterDrawerClose}
            >
              <div className="margin-down-5 border-bottom padding-10">
                <div className="side-bar-title flex-gap flex justify-content-between padding-y-10">
                  <span className="bolder">{t("registerANewStudent")}</span>
                  <div className="center">
                    <CancelIcon
                      onClick={handleRagisterDrawerClose}
                      className="pointer"
                    />
                  </div>
                </div>

                <span></span>
              </div>
              <div className="padding-20">
                <RegisterNewStudent
                  handleClose={handleRagisterDrawerClose}
                  handleOpen={handleRegisterDrawerOpen}
                  handleOpenStudentModal={handleOpenStudentModal}
                />
              </div>
            </Drawer>
          </React.Fragment>
        ))}

        <RightDrawerLarge
          open={ragisterDrawer}
          onClose={handleRegisterDrawerClose}
          title={t("registerANewStudent")}
          content={
            <RegisterNewStudent
              lead={lead}
              handleClose={handleRegisterDrawerClose}
              ciNameOptions={ciNameOptions}
              countryOptions={countryOptions}
              batchNameOptions={batchNameOptions}
              promoCodeOptions={promoCodeOptions}
              refferedByOptions={refferedByOptions}
              courseNameOptions={courseNameOptions}
              levelStatusOptions={levelStatusOptions}
              modeOfPaymentOptions={modeOfPaymentOptions}
              primaryBenefitOptions={primaryBenefitOptions}
              sourceOfEnquiryOptions={sourceOfEnquiryOptions}
              registrationTypeOptions={registrationTypeOptions}
              newStudentCreated={handleModifiedStudentData}
            />
          }
        />

        <ModalDialog
          state={modalOpen}
          title={t("addSchool")}
          onClose={handleModalClose}
          size="s"
          content={
            <Addschool
              schoolNameAdded={schoolNameAdded}
              handleModalClose={handleModalClose}
            />
          }
        ></ModalDialog>
      </div>
    </div>
  );
}
